import axios from 'axios';
import { io } from 'socket.io-client';

const BASE = process.env.REACT_APP_API_URL || 'https://emailback.itsybizz.com';
const api = axios.create({ baseURL: `${BASE}/api` });
export const socket = io(BASE);

// SMTP
export const getSmtpConfigs = () => api.get('/smtp');
export const getSmtpPresets = () => api.get('/smtp/presets');
export const createSmtpConfig = (d) => api.post('/smtp', d);
export const testSmtpConfig = (d) => api.post('/smtp/test', d);
export const sendTestEmail = (d) => api.post('/smtp/send-test', d);
export const deleteSmtpConfig = (id) => api.delete(`/smtp/${id}`);

// Templates
export const getTemplates = () => api.get('/templates');
export const getTemplate = (id) => api.get(`/templates/${id}`);
export const createTemplate = (formData) => api.post('/templates', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateTemplate = (id, formData) => api.put(`/templates/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteTemplate = (id) => api.delete(`/templates/${id}`);

// Contacts
export const getContacts = (params) => api.get('/contacts', { params });
export const getContactTags = () => api.get('/contacts/tags');
export const createContact = (d) => api.post('/contacts', d);
export const updateContact = (id, d) => api.put(`/contacts/${id}`, d);
export const uploadContacts = (formData) => api.post('/contacts/bulk', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteContact = (id) => api.delete(`/contacts/${id}`);
export const bulkAddTag = (d) => api.put('/contacts/bulk/add-tag', d);
export const bulkRemoveTag = (d) => api.put('/contacts/bulk/remove-tag', d);
export const bulkDeleteContacts = (d) => api.post('/contacts/bulk-delete', d);

// Campaigns
export const getCampaigns = () => api.get('/campaigns');
export const getCampaign = (id) => api.get(`/campaigns/${id}`);
export const createCampaign = (d) => api.post('/campaigns', d);
export const updateCampaign = (id, d) => api.put(`/campaigns/${id}`, d);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`);
export const getCampaignEmails = (id, status) => api.get(`/campaigns/${id}/emails`, { params: { status } });
export const sendCampaign = (id) => api.post(`/campaigns/${id}/send`);
export const pauseCampaign = (id) => api.post(`/campaigns/${id}/pause`);
export const resumeCampaign = (id) => api.post(`/campaigns/${id}/resume`);
export const stopCampaign = (id) => api.post(`/campaigns/${id}/stop`);
export const checkReplies = (id) => api.post(`/campaigns/${id}/check-replies`);
export const getCampaignReplies = (id) => api.get(`/campaigns/${id}/replies`);

// Chat / Replies
export const getEmailChat = (emailId) => api.get(`/campaigns/email/${emailId}/chat`);
export const sendReply = (emailId, body) => api.post(`/campaigns/email/${emailId}/reply`, { body });

// WhatsApp
export const getWaConfigs = () => api.get('/whatsapp/config');
export const createWaConfig = (d) => api.post('/whatsapp/config', d);
export const testWaConfig = (d) => api.post('/whatsapp/config/test', d);
export const deleteWaConfig = (id) => api.delete(`/whatsapp/config/${id}`);
export const getWaTemplates = () => api.get('/whatsapp/templates');
export const getWaTemplate = (id) => api.get(`/whatsapp/templates/${id}`);
export const createWaTemplate = (d) => api.post('/whatsapp/templates', d);
export const updateWaTemplate = (id, d) => api.put(`/whatsapp/templates/${id}`, d);
export const deleteWaTemplate = (id) => api.delete(`/whatsapp/templates/${id}`);
export const sendWaCampaign = (id) => api.post(`/whatsapp/campaigns/${id}/send`);
export const sendWaReply = (emailId, body) => api.post(`/whatsapp/reply/${emailId}`, { body });

// Dashboard
export const getDashboard = (params) => api.get('/dashboard', { params });
export const getEmailLogs = (params) => api.get('/email-logs', { params });
export const downloadEmailLogs = (params) => {
  const query = new URLSearchParams(params).toString();
  window.open(`${BASE}/api/email-logs/download?${query}`, '_blank');
};

// Bounce + Reply check
export const checkAllReplies = () => api.post('/campaigns/check-all-replies');
export const checkBounces = () => api.post('/check-bounces');

export default api;
